export default __webpack_public_path__ + "static/media/txt.b3019163.png";